import styles from "./CaretDownIcon.module.scss"

const CaretDownIcon = ({open}) => {
  return (
    <span className={[styles.select, open ? styles.menuOpen: ''].join(" ")}>
      <span className={[styles.arrow].join(" ")}>
        <svg
          className={styles.arrowLeft}
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 7L1 1" stroke="#FFFFFF" strokeWidth="2"></path>
        </svg>
        <svg
          className={styles.arrowRight}
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 1L1 7" stroke="#FFFFFF" strokeWidth="2"></path>
        </svg>
      </span>
    </span>
  )
}

export default CaretDownIcon
